import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap, tap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RemoveReportFiltersService } from '../remove-report-filters.service';
import { ToastrService } from 'ngx-toastr';
import {
  removeReportFiltersAction,
  removeReportFiltersFailureAction,
  removeReportFiltersSuccessAction,
} from './remove-report-filters.actions';

@Injectable()
export class RemoveReportFiltersEffects {
  removeReportFilter$ = createEffect(() => this.actions$.pipe(
    ofType(removeReportFiltersAction),
    switchMap(action =>
      this.removeReportFiltersService.remove(action.payload).pipe(
        map(data => removeReportFiltersSuccessAction({data})),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        catchError(error => of(removeReportFiltersFailureAction({error}))),
      )
    )
  ));

  removeReportFiltersSuccess$ = createEffect(() => this.actions$.pipe(
    ofType(removeReportFiltersSuccessAction),
    tap(() =>
      this.notifyService.success('Report filter successfully removed')
    ),
  ), {dispatch: false});

  removeReportFiltersFailure$ = createEffect(() => this.actions$.pipe(
    ofType(removeReportFiltersFailureAction),
    tap(() =>
      this.notifyService.error('Failed to remove report filters')
    ),
  ), {dispatch: false});

  constructor(
    private actions$: Actions,
    private removeReportFiltersService: RemoveReportFiltersService,
    private notifyService: ToastrService,
  ) {
  }
}
